import { Component, EventEmitter, Output } from '@angular/core';
import * as Msal from 'msal';
import { User } from '../../../Model/user.Model';
import { UserVistaPermissions } from '../../../Model/UserPermission.Model';
import { MarketCompany } from '../../../Model/MarketCompany.Model';
import { GenericService } from '../../../Services/generic.service';
import { AuthenticationService } from '../../../auth/authentication.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  standalone: false
})
export class HeaderBarComponent {
  title = 'vista-app';
  Users: User[];
  CurrentUser: User;
  usersPermissions: UserVistaPermissions[];
  CurrentuserPermissions: UserVistaPermissions;
  //UserName: string = '';
  UserId: string;
  Intervalle: any;
  BaseUrl: string = localStorage.getItem('Vista_urlapi');
  host: string = localStorage.getItem('Vista_HostName');
  env: string = localStorage.getItem('Vista_EnvironementProd');
  TenantId: string = '';
  ClientId: string = '';
  ClientIdWebApi: string = '';
  authority: string = '';
  scope: string = '';
  ClientSecret: string = '';
  myMSALObj: Msal.UserAgentApplication;
  UserName: string = '';
  app_version = localStorage.getItem('AppVersion');
  FilterMco: boolean = false;
  marketCompanies: MarketCompany[];
  selectedMarket: MarketCompany = null;
  marketcompanies: MarketCompany[];
  CurrentUserId: string;
  public permissionDataVisualisation: boolean = true;
  public permissionDataParameters: boolean = true;
  public permissionSettings: boolean = true;
  @Output() onNavigate: EventEmitter<string> = new EventEmitter<string>();
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private genericService: GenericService,
    public auth: AuthenticationService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.auth.isLoadingBehaviour$.subscribe(
      (response) => {
        if (response == false) {
          this.PermissionDataVisualisation();
          this.PermissionDataParameters()
          this.PermissionSettings()
        }
      }
    )
    this.ClientId = localStorage.getItem('ClientId');
    this.ClientIdWebApi = localStorage.getItem('ClientIdWebApi');
    this.TenantId = localStorage.getItem('TenantId');
    this.authority = localStorage.getItem('Authority');
    this.scope = localStorage.getItem('Scope');
    this.CurrentUserId = localStorage.getItem('Vista_userId');

    /*  this.userIdle.startWatching();
     this.userIdle.onTimerStart().subscribe((count) => console.log(count));
     this.userIdle.onTimeout().subscribe(() => this.timeUp()); */

    // let redirect = this.env == '1' ? 'https://' + this.host : 'http://' + this.host;

    // sets an idle timeout of 5 seconds, for testing purposes.
    this.idle.setIdle(600);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(5);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.Logout();
    });

    this.idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
    this.idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
    this.reset();

    let protocole = this.env == '1' ? 'https://' : 'http://';
    let redirect = protocole + this.host;
    // for dev
   // let redirect = 'http://' + this.host;

    var msalConfig: Msal.Configuration = {
      auth: {
        clientId: this.ClientId,
        authority: this.authority + this.TenantId,
        redirectUri: redirect,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    };

    this.myMSALObj = new Msal.UserAgentApplication(msalConfig);

    let _scope = 'api://' + this.ClientIdWebApi + '/' + this.scope;

    var requestObj = {
      scopes: [_scope],
    };

    this.myMSALObj.handleRedirectCallback((x: any) => { });

    //this.myMSALObj.acquireTokenSilent(requestObj).then((loginResponse: any) => {
    //  localStorage.setItem('access_token', loginResponse.accessToken);
    //  localStorage.setItem('Vista_userEmail', loginResponse.account.userName);
    //  this.Initdata();

    //}).catch((error: any) => {
    //  if (this.requiresInteraction(error.errorCode)) {
    //    this.myMSALObj.loginRedirect(requestObj);
    //  }
    //});

    this.myMSALObj.acquireTokenSilent(requestObj).then(
      (accessToken: any) => {
        localStorage.setItem('access_token', accessToken.accessToken);
        localStorage.setItem('Vista_userEmail', accessToken.account.userName);
        this.Initdata();
      },
      (error: any) => {
        if (this.myMSALObj.getAccount() != null) {
          this.myMSALObj.acquireTokenRedirect(requestObj);
        } else {
          this.myMSALObj.loginRedirect(requestObj);
        }
      }
    );
  }

  /**
   * Handle inactivity callback
   */
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  requiresInteraction(errorCode): boolean {
    if (!errorCode || !errorCode.length) {
      return false;
    }
    return (
      errorCode === 'consent_required' ||
      errorCode === 'interaction_required' ||
      errorCode === 'login_required' ||
      errorCode === 'user_login_error'
    );
  }

  Logout() {
    this.myMSALObj.logout();
  }

  ngOnDestroy() {
    this.ClearBrowser();
    clearInterval(this.Intervalle);
  }

  ClearBrowser(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('expires_in');
    localStorage.removeItem('generes_in');
    localStorage.removeItem('Vista_selectedFilterMarket');
  }

  Initdata() {
    this.marketCompanies = [];
    this.auth.AuthToken();
    this.auth.event.subscribe((val) => {
      this.UserName = val;
    });
    this.auth.eventShowMco.subscribe((val) => {
      this.FilterMco = val == '1' ? true : false;
      localStorage.setItem('Vista_selectedFilterMarket', '0');
    });
    this.auth.eventMcos.subscribe((val) => {
      this.marketCompanies = val;
    });
  }

  onselectMarketco(ev: any) {
    this.genericService.resetAllList();
    localStorage.setItem('Vista_selectedFilterMarket', '0');
    this.selectedMarket = ev;
    if (
      this.selectedMarket != null &&
      +this.selectedMarket.marketCompanyId > 0
    ) {
      localStorage.setItem(
        'Vista_selectedFilterMarket',
        this.selectedMarket.marketCompanyId.toString()
      );
    }
    // this.router.navigate(['/home']);
    this.getMarketCompany();
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  getMarketCompany(): void {
    if (
      this.genericService.ListMarketCompany == null ||
      this.genericService.ListMarketCompany.length < 1
    ) {
      this.genericService
        .get(
          this.BaseUrl.concat(
            'api/MarketCompanyApi/GetAll?id=' + this.CurrentUserId
          )
        )
        .subscribe((data: any) => {
          this.marketcompanies = data;
          this.genericService.ListMarketCompany = data;
        });
    } else {
      this.marketcompanies = this.genericService.ListMarketCompany;
    }
  }

  PermissionDataVisualisation() {

    if (
      this.auth.UserPermission.MarketCoMasterData == true ||
      this.auth.UserPermission.FinacialInformationData ==
      true ||
      this.auth.UserPermission.EposInformationData == true ||
      this.auth.UserPermission.PromotionPlansData == true ||
      this.auth.UserPermission.AdvancedData == true
    ) {

      this.permissionDataVisualisation = true;
    } else {
      this.permissionDataVisualisation = false;
    }
  }

  PermissionDataParameters() {
    if (
      this.auth.UserPermission.FinacialParameters == true ||
      this.auth.UserPermission.PromotionParameters == true ||
      this.auth.UserPermission.DailyRosFirstDayParameters ==
      true ||
      this.auth.UserPermission.SeasonalitesParameters ==
      true ||
      this.auth.UserPermission.EposManagementParameters ==
      true ||
      this.auth.UserPermission.AdvancedParameters == true ||
      this.auth.UserPermission.AdditionalParameters == true ||
      this.auth.UserPermission.PricingParameters == true ||
      this.auth.UserPermission.CompetitionParameters == true
    ) {
      this.permissionDataParameters = true;
    } else {
      this.permissionDataParameters = false;
    }
  }

  PermissionSettings() {
    if (
      this.auth.UserPermission.Settings == true ||
      this.auth.UserPermission.Monitoring == true ||
      this.auth.CoherencyTest === 1
    ) {
      this.permissionSettings = true;
    } else {
      this.permissionSettings = false;
    }
  }

}

